/* eslint-disable */
import Splide from '@splidejs/splide';

export default {
  init() {
    const bannerSlider = new Splide('.splide--banner-slider', {
      type: 'slide',
      perPage: 1,
      perMove: 1,
      pagination: true,
      arrows: false,
      autoplay: true,
      interval: 4000,
    });
    bannerSlider.mount();

    const tabs = document.querySelector(".tabs");
    if (tabs) {
      const tabsBtns = tabs.querySelectorAll(".tabs__btn");
      const tabsContents = tabs.querySelectorAll(".tabs__content");
      const tabsWrapper = document.querySelectorAll(".stages-wrapper");
      function displayCurrentTab(current) {
        tabsWrapper[current].classList.add("active");
        for (let i = 0; i < tabsContents.length; i++) {
          tabsContents[i].style.display = current === i ? "block" : "none";
          if (current === i) {
            setTimeout(() => {
              tabsContents[i].classList.add("active");
            }, 300);
          } else {
            setTimeout(() => {
              tabsContents[i].classList.remove("active");
            }, 300);
          }
        }
      }
      function removeActiveFromTab() {
        document.querySelectorAll(".tabs__btn").forEach((item) => {
          item.classList.remove("active");
        });

        document.querySelectorAll(".stages-wrapper").forEach((item) => {
          item.classList.remove("active");
        });
      }
      displayCurrentTab(0);

      tabs.addEventListener("click", (event) => {
        if (event.target.classList.contains("tabs__btn")) {
          removeActiveFromTab();
          for (let i = 0; i < tabsBtns.length; i++) {
            if (event.target === tabsBtns[i]) {
              event.target.classList.add("active");
              displayCurrentTab(i);
              break;
            } else {
              removeActiveFromTab();
            }
          }
        }
      });
    } else {
      console.error("Element not found!");
    }
    const counters = document.querySelectorAll(".count");
    const speed = 200;

    const section = document.getElementsByClassName("join-numbers-wrappers")[0];

    const startCounters = () => {
      counters.forEach((counter) => {
        const target = parseTarget(counter.getAttribute("data-target"));
        const increment = Math.max(Math.trunc(target / speed), 1); // Use Math.max() to ensure the increment is at least 1

        const updateCount = () => {
          const count = parseCount(counter.innerText);

          if (count < target) {
            const updatedCount = count + increment;
            counter.innerText =
              updatedCount +
              getAdditionalText(counter.getAttribute("data-target"));
            setTimeout(updateCount, 1);
          } else {
            counter.innerText =
              target + getAdditionalText(counter.getAttribute("data-target"));
          }
        };

        updateCount();
      });
    };

    // Helper function to parse the target value
    const parseTarget = (targetString) => {
      const matches = targetString.match(/\d+/);
      return matches ? parseInt(matches[0]) : 0;
    };

    // Helper function to parse the current count
    const parseCount = (countString) => {
      const matches = countString.match(/\d+/);
      return matches ? parseInt(matches[0]) : 0;
    };

    // Helper function to get the additional text from the target
    const getAdditionalText = (targetString) => {
      const matches = targetString.match(/[^\d]+/);
      return matches ? matches[0] : "";
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          startCounters();
          // Stop observing the section once it becomes visible (if you only want to trigger once)
          observer.unobserve(entry.target);
        }
      });
    });

    observer.observe(section);
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};
